import {config} from "@/constants/config";
import {httpRequest} from "@/providers/http";
import {adaptContacts, adaptSingleContact} from "./contacts.adapter";
import type {Contact, ContactApiResponse, ContactsApiResponse} from "./contacts.types";

export const listContactsService = async (): Promise<Contact[]> => {
  const response = await httpRequest<ContactsApiResponse>({
    method: "GET",
    url: "/user/contacts/list",
    baseUrl: config.apiBaseUrl,
  });
  return adaptContacts(response);
};

export const searchContactByEmailService = async (email: string): Promise<Contact | null> => {
  const response = await httpRequest<ContactApiResponse>({
    method: "GET",
    url: "/user/contacts/search",
    baseUrl: config.apiBaseUrl,
    query: {email},
  });
  return adaptSingleContact(response);
};

export const addContactService = async (contactId: string): Promise<unknown> => {
  return httpRequest<unknown, {contact_id: string}>({
    method: "POST",
    url: "/user/contacts/create",
    baseUrl: config.apiBaseUrl,
    body: {contact_id: contactId},
  });
};

export interface UpdateContactPayload {
  ID: string;
  nickname?: string;
}

export const updateContactService = async (payload: UpdateContactPayload): Promise<unknown> => {
  return httpRequest<unknown, UpdateContactPayload>({
    method: "PATCH",
    url: "/user/contacts/update",
    baseUrl: config.apiBaseUrl,
    body: payload,
  });
};

export const deleteContactService = async (id: string): Promise<unknown> => {
  return httpRequest<unknown>({
    method: "DELETE",
    url: `/user/contacts/delete/${encodeURIComponent(id)}`,
    baseUrl: config.apiBaseUrl,
  });
};
